module.exports = __webpack_public_path__ + "info-solid.svg?80fe52542f96a09b57a8411f9182f9fb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/info-solid.svg
// module id = 178
// module chunks = 0